import script from "./FollowersForm.vue?vue&type=script&setup=true&lang=js"
export * from "./FollowersForm.vue?vue&type=script&setup=true&lang=js"

import "./FollowersForm.vue?vue&type=style&index=0&id=d099d7f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d099d7f8"]])

export default __exports__